import { NgModule } from "@angular/core";
import { SharedModule } from "../../../shared/shared.module";

import { InviteManagerComponent } from "./invite-manager.component";
import { InviteManagerRoutingModule } from "./invite-manager-routing.module";
import { InviteManagerNavTabsComponent } from "./invite-manager-nav-tabs/invite-manager-nav-tabs.component";
import { InviteManagerAuthResolver } from "./invite-manager-auth-resolver.service";

@NgModule({
  imports: [InviteManagerRoutingModule, SharedModule],
  declarations: [InviteManagerComponent, InviteManagerNavTabsComponent],
  providers: [InviteManagerAuthResolver],
})
export class InviteManagerModule {}
